import { MMButton } from '@components'
import { useFakeBankLogin } from '@views/CheckoutPayment/useFakeBankLogin'
import { FakeJetonbankBanks } from 'mmfintech-checkout-commons'
import { tr } from 'mmfintech-commons'
import { ErrorDisplay, Input } from 'mmfintech-portal-commons'

type FakeLoginPaneProps = {
  countryCode: string
  backChoiceId: string
  onCancel: () => void
}

const FakeLoginPane = ({ countryCode, backChoiceId, onCancel }: FakeLoginPaneProps) => {
  const fakeLogin = useFakeBankLogin()

  const getFakeBankIndex = () => {
    const index = Number.parseInt(backChoiceId)
    return Number.isFinite(index) ? index - 1 : -1
  }

  const handleFakePay = () => {
    if (fakeLogin.values.areValid()) {
      void fakeLogin.login(FakeJetonbankBanks[countryCode][getFakeBankIndex()]?.url)
    }
  }

  return (
    <>
      <div style={{ fontSize: '1.8rem', fontWeight: '500', marginBottom: '2rem' }}>
        {tr('CHECKOUT.BANK_LOGIN_REQUEST.TITLE', 'Login to')}{' '}
        {FakeJetonbankBanks[countryCode][getFakeBankIndex()]?.name}
      </div>

      <Input
        type='text'
        label={tr('CHECKOUT.BANK_LOGIN_REQUEST.USERNAME', 'Username')}
        {...fakeLogin.values.registerInput('username')}
        hideErrorLine
        autoComplete='off'
      />

      <Input
        type='password'
        label={tr('CHECKOUT.BANK_LOGIN_REQUEST.PASSWORD', 'Password')}
        {...fakeLogin.values.registerInput('password')}
        hideErrorLine
        autoComplete='off'
      />

      <ErrorDisplay error={fakeLogin.error} />

      <div className='buttons'>
        <MMButton
          type='button'
          variant='primary'
          caption={tr('CHECKOUT.BANK_LOGIN_REQUEST.LOGIN', 'Login')}
          onClick={handleFakePay}
          loading={fakeLogin.loading}
          fullWidth
        />
        <MMButton
          type='button'
          variant='secondary'
          caption={tr('CHECKOUT.BANK_LOGIN_REQUEST.CANCEL', 'Cancel')}
          onClick={onCancel}
          disabled={fakeLogin.loading}
          fullWidth
        />
      </div>
    </>
  )
}

export default FakeLoginPane
